<div
  class="surface-default p-3.5 sm:px-5 sm:py-3.5 rounded-2xl border border-gray-6 shadow-xs text-xs space-y-2.5"
>
  <!-- Top line: Role + Status Badge + Non-modifiable pill -->
  <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-2.5">
    <div class="flex items-center gap-2.5 flex-wrap">
      <div
        class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-indigo-a3 text-indigo-11 border border-indigo-a4"
      >
        <mat-icon class="text-sm! w-4! h-4!">badge</mat-icon>
      </div>

      <div class="flex items-center gap-2 flex-wrap">
        <span class="text-gray-10 font-bold uppercase tracking-wider text-[10px]">Déclarant du bien :</span>
        <span
          class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md bg-indigo-a3 text-indigo-11 border border-indigo-a5 font-bold text-xs"
        >
          {{ seller()?.role | etxeEnumDisplay: 'sellerRole' }}
        </span>

        @if (definition()?.residenceType) {
          <span
            class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md bg-gray-a3 text-gray-12 border border-gray-a5 font-semibold text-xs"
          >
            <mat-icon class="text-xs! w-3.5! h-3.5!">home</mat-icon>
            {{ definition()?.residenceType | etxeEnumDisplay: 'residenceType' }}
          </span>
        }

        @if (marketStatus(); as market) {
          <span
            class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md bg-blue-a3 text-blue-11 border border-blue-a5 font-semibold text-xs"
          >
            <mat-icon class="text-xs! w-3.5! h-3.5!">storefront</mat-icon>
            {{ market.state | etxeEnumDisplay: 'marketState' }}
          </span>

          <span
            class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md bg-amber-a3 text-amber-11 border border-amber-a5 font-semibold text-xs capitalize"
          >
            <span class="text-[10px] text-gray-10 font-normal">Origine :</span>
            {{ market.source | etxeEnumDisplay: 'creationSource' }}
          </span>
        }
      </div>
    </div>

    <div class="shrink-0 self-start sm:self-auto">
      <span
        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-gray-a3 text-gray-11 text-[11px] font-medium border border-gray-a5"
      >
        <mat-icon class="text-[11px]! w-3! h-3!">lock</mat-icon>
        Information non modifiable
      </span>
    </div>
  </div>

  <!-- Beneficiary details (compact inline format) -->
  @if (isNonOwner() && beneficiary(); as b) {
    <div
      class="pt-2 border-t border-gray-5/60 flex flex-wrap items-center gap-x-4 gap-y-1 text-gray-12 text-[11px]"
    >
      @if (b.firstName || b.lastName) {
        <span class="flex items-center gap-1">
          <span class="text-gray-10 font-medium">Représenté :</span>
          <strong class="font-bold">{{ b.firstName }} {{ b.lastName }}</strong>
        </span>
      }
      @if (b.email) {
        <span class="flex items-center gap-1 text-gray-11">
          <mat-icon class="text-[11px]! w-3! h-3! text-gray-10">mail</mat-icon>
          <span>{{ b.email }}</span>
        </span>
      }
      @if (b.phone) {
        <span class="flex items-center gap-1 text-gray-11">
          <mat-icon class="text-[11px]! w-3! h-3! text-gray-10">call</mat-icon>
          <span>{{ b.phone }}</span>
        </span>
      }
      @if (seller().role === PropertySellerRole.COMPANY && b.companyName) {
        <span class="flex items-center gap-1">
          <span class="text-gray-10">Société :</span>
          <strong class="font-bold">{{ b.companyName }}</strong>
          @if (b.siren) {
            <span class="text-gray-10">({{ b.siren }})</span>
          }
        </span>
      }
      @if (seller().role === PropertySellerRole.ESTATE_HEIR && b.estateName) {
        <span class="flex items-center gap-1">
          <span class="text-gray-10">Succession :</span>
          <strong class="font-bold">{{ b.estateName }}</strong>
          @if (b.notaryName) {
            <span class="text-gray-10">(Notaire: {{ b.notaryName }})</span>
          }
        </span>
      }
    </div>

    @if (seller().representationDetails) {
      <div class="text-[11px] text-gray-11 italic pl-2 border-l-2 border-indigo-a6">
        « {{ seller().representationDetails }} »
      </div>
    }
  }
</div>
